import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { LyricTimingPill, LyricTimingPillTone } from './LyricTimingPill';
import { lyricTimingMessages } from './lyricTimingMessages';
import { Panel, PanelBody, PanelHead } from '../../../../music24/components/primitives/Panel';
import { withBrandWord } from '../../../../music24/components/primitives/BrandWord';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the lyric timing; each part uses its own slice of it */
import styles from './LyricTiming.module.scss';
/* eslint-enable css-modules/no-unused-class */

export interface LyricTimingCardAction {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

interface LyricTimingStateCardProps {
  tone: LyricTimingPillTone;
  /** The state pill. With none, the card has no pill (the page of a song that is not found). */
  pill?: string;
  /** One or more sentences. */
  body: React.ReactNode;
  actions?: LyricTimingCardAction[];
}

/**
 * One state of the lyric timing with no line list (design s8b): no lyrics, no master, a failed
 * sync, a song that is not synced yet. The title, the pill, the sentence and the buttons.
 */
const LyricTimingStateCardComponent: React.FC<LyricTimingStateCardProps> = ({ tone, pill, body, actions }) => {
  const intl = useIntl();
  return (
    <Panel data-testid="lyric-timing-state">
      <PanelHead
        title={intl.formatMessage(lyricTimingMessages.title)}
        right={pill !== undefined && <LyricTimingPill tone={tone} label={pill} />}
      />
      <PanelBody className={styles.state}>
        <span>{withBrandWord(body)}</span>
        {actions !== undefined && actions.length > 0 && (
          <div className={styles.actions}>
            {actions.map((action) => (
              <button
                key={action.label}
                type="button"
                className={styles.button}
                onClick={action.onClick}
                disabled={action.disabled === true}
              >
                {action.label}
              </button>
            ))}
          </div>
        )}
      </PanelBody>
    </Panel>
  );
};

export const LyricTimingStateCard = TypedMemo(LyricTimingStateCardComponent);
